import { useStaticQuery, graphql } from 'gatsby';
import getCountryISO2 from 'country-iso-3-to-2';
import countries from 'i18n-iso-countries';
import countriesPt from 'i18n-iso-countries/langs/pt.json';
import countriesEn from 'i18n-iso-countries/langs/en.json';
import countriesEs from 'i18n-iso-countries/langs/es.json';

countries.registerLocale(countriesPt);
countries.registerLocale(countriesEn);
countries.registerLocale(countriesEs);

export const useFlags = (countryName = 'BRA') => {
  const flag = getCountryISO2(countryName);

  const data = useStaticQuery(graphql`
    {
      allFile(filter: { sourceInstanceName: { eq: "flags" } }) {
        edges {
          node {
            name
            publicURL
          }
        }
      }
    }
  `);

  if (!countryName) return { ...data.allFile.edges[29].node };

  const filteredCountry = data.allFile.edges
    .filter(item => item.node.name === flag.toLowerCase())
    .pop();
  return { ...filteredCountry.node };
};

export const getCountries = lang => {
  return Object.entries(countries.getNames(lang)).reduce(
    (list, [key, value]) => {
      list.push({
        code: key,
        name: typeof value === 'object' ? value[0] : value,
      });
      return list;
    },
    []
  );
};
